<template>
<div>
    <submission-title
        v-if="!hide_title"
        :form_name="`${formSubmissionComputed?.instance?.form?.name} - ${certificateComputed?.name}`"
        :form_status="formSubmissionComputed?.form_status ?? false"
    />

    <submission-subtitle :form_status="formSubmissionComputed.form_status" />

    <div class="form-submission-card-content">
        <response-text
            :question="certificateComputed.user.full_name"
            :answer="`Expiry Date: ${certificateComputed.expires_at_formatted_small}`"
        />

        <gallery-view-component
            v-if="certificateComputed.documents"
            class="form-submission-card-content-child"
            :photos="certificateComputed.documents"
        />
    </div>
</div>
</template>

<script>
import GalleryViewComponent from '../general_components/GalleryViewComponent';
import SubmissionTitle from '../submissions/SubmissionTitle';
import SubmissionSubtitle from '../submissions/SubmissionSubtitle';
import ResponseText from '../submissions/responses/ResponseText.vue';

export default {
    name: 'TrainingCertificateSubmission',
    components: {
        GalleryViewComponent,
        SubmissionTitle,
        SubmissionSubtitle,
        ResponseText,
    },
    props: {
        form_submission: Object,
        certificate: Object,
        hide_title: Boolean,
    },
    computed: {
        formSubmissionComputed() {
            return this.form_submission ?? this.certificate.form_submission;
        },

        certificateComputed() {
            return this.certificate ?? this.form_submission?.certificate;
        },
    },
};
</script>
